import React from 'react';
import { SiPython, SiCplusplus } from 'react-icons/si';
import { FaJava } from 'react-icons/fa';
import './Languages.css';

function Languages() {
    const languages = [
        { name: 'Python', icon: <SiPython size={36} />, status: 'completed', label: 'Completed' },
        { name: 'Java', icon: <FaJava size={36} />, status: 'in-progress', label: 'In Progress' },
        { name: 'C++', icon: <SiCplusplus size={36} />, status: 'not-started', label: 'Not Started' }
    ];

    return (
        <div className="programming-languages-container">
            {languages.map((lang) => (
                <div key={lang.name} className="language-item">
                    <div className="lang-svg-icon">{lang.icon}</div>
                    <div className="language-text">{lang.name}</div>
                    <div className={`status ${lang.status}`}>{lang.label}</div>
                </div>
            ))}
        </div>
    );
}

export default Languages;